import { getClient } from "./client"
import { fetchRefreshToken } from "@/apis/auth"
import { getOrigin } from "./host"
import { agent, client } from "myoa-lib-js"

// 获取token
export async function getAccessToken() {
  const client = getClient()
  const getClientTokenFun = client.getAccessToken || client.getUserAccessToken || client.getToken

  return getClientTokenFun ? await getClientTokenFun() : localStorage.getItem('accessToken')
}

// 缓存token
export function saveTokenCache(data = {}) {
  localStorage.setItem('accessToken', data.accessToken)
  localStorage.setItem('refreshToken', data.refreshToken)
  localStorage.setItem('organizationId', data.organizationId)
}

// 读取token缓存
export function getTokenCache() {
  const refreshToken = localStorage.getItem('refreshToken')
  const organizationId = localStorage.getItem('organizationId')

  return {
    refreshToken, organizationId
  }
}

export function clearTokenCache() {
  ['accessToken', 'refreshToken', 'organizationId'].forEach(i => localStorage.removeItem(i))
}

// 刷新token
export const refreshToken = async () => {
  // 判断是否有本地缓存refreshToken
  const cache = getTokenCache()
  if (!cache.refreshToken) {
    console.log('refreshToken不存在')
    return false
  }

  const { data: { accessToken, refreshToken } } = await fetchRefreshToken(cache)
  return {
    accessToken, refreshToken, organizationId: cache.organizationId
  }
}

export async function clearAuth() {
  console.log('重定向到登陆')

  clearTokenCache()

  if (agent.isWEB()) {
    // web端跳转对应的登录页面
    window.location.href = getOrigin() + `/web/auth-login/login.html?redirect=${encodeURIComponent(window.location.href)}`
  } else {
    await client.getClient()
    window.top.client.logout()
  }
}